import store from '../redux/store';

export function showMegaMenu() {
  const featureLocks = store.getState()?.commonReducer?.featureLocksData.featureLocks;
  return (
    featureLocks?.collections?.isVisible &&
    store.getState()?.catalogReducer?.collections?.length > 0
  );
}
